import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMessageSquare,FiPhoneCall,FiSend} = FiIcons;

const steps = [
  {
    day: 'Day 1',
    title: 'We text your list',
    description: 'Our team starts working through your past leads and customers with the follow-up you have not had time to send.',
    icon: FiMessageSquare
  },
  {
    day: 'Day 2',
    title: 'We follow up again',
    description: 'Buyers are busy. We keep the conversation moving and make sure your name stays in front of warm opportunities.',
    icon: FiSend
  },
  {
    day: 'Day 3',
    title: 'We call and reconnect',
    description: 'No response? We call. The moment someone says they are interested, we hand them directly to you to close.',
    icon: FiPhoneCall
  }
];

const ProcessTimeline = () => (
  <section className="border-y border-black bg-neutral-50 px-4 py-20 sm:px-8 md:py-28">
    <div className="mx-auto max-w-6xl">
      <p className="font-sans text-xs font-black uppercase tracking-[0.24em] text-neutral-600">
        Here&apos;s how it works
      </p>
      <h2 className="mt-4 max-w-4xl text-3xl font-black uppercase leading-[0.98] tracking-tight text-black sm:text-4xl md:text-5xl">
        You close. We work the list. That&apos;s the whole deal.
      </h2>

      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {steps.map((step, index) => (
          <article
            key={step.day}
            className="relative border-2 border-black bg-white p-7 shadow-[7px_7px_0_#facc15]"
          >
            <span className="font-sans text-xs font-black uppercase tracking-[0.18em] text-neutral-500">
              {step.day}
            </span>
            <span className="mt-6 flex h-12 w-12 items-center justify-center rounded-full bg-black text-yellow-400">
              <SafeIcon icon={step.icon} className="text-xl" />
            </span>
            <h3 className="mt-6 text-2xl font-black uppercase text-black">{step.title}</h3>
            <p className="mt-4 text-base leading-relaxed text-neutral-700">{step.description}</p>
            {index < steps.length - 1 && (
              <span className="absolute -bottom-9 left-1/2 hidden -translate-x-1/2 font-sans text-3xl font-black text-black md:block">
                →
              </span>
            )}
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessTimeline;